import React from 'react';

const FinalSummary = ({ finalSummaryData }) => {

  if (!finalSummaryData?.rows) return null;

  return (
    <div className="yr40-card">

      <div className="yr40-title">
        &#127942; End of Term &mdash; Final Year Fund Values
      </div>

      <div style={{ overflowX: 'auto' }}>

        <table className="yr40-table">

          <thead>
            <tr>
              <th>Company / Fund</th>
              <th>Policy Term</th>
              <th>Final Year Fund Value</th>
              <th>Total Premium Paid</th>
              <th>Multiple on Investment</th>
            </tr>
          </thead>

          <tbody>

            {[...finalSummaryData.rows].map((item, index) => {

              const isBest =
                item.title?.toLowerCase().includes("best");

              const policyTerm =
                typeof item.policyTerm === "number"
                  ? item.policyTerm + " Years"
                  : item.policyTerm;

              const rowClass =
                isBest ? "best-row" : "";

              const valueColor =
                isBest
                  ? "#d97706"
                  : "#1A2B5F";

              return (
                <tr
                  key={index}
                  className={rowClass}
                >

                  <td>

                    {isBest && "⭐⭐ "}

                    <b>{item.title || ""}</b>

                    <br />

                    <span
                      style={{
                        fontWeight: 400,
                        color: "#666",
                        fontSize: "12px"
                      }}
                    >
                      {item.fundName || ""}
                    </span>

                  </td>

                  <td>
                    {policyTerm}
                  </td>

                  <td
                    style={{
                      fontWeight: '800',
                      color: valueColor
                    }}
                  >
                    {item.finalYearFundValueLabel || "₹0"}
                  </td>

                  <td>
                    {item.totalPremiumPaidLabel || "-"}
                  </td>

                  <td>
                    <span className="mult-badge mult-high">
                      {item.multiple || "0x"}
                    </span>
                  </td>

                </tr>
              );
            })}

          </tbody>

        </table>

      </div>
    </div>
  );
};

export default FinalSummary;